import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import getLuma from '../../../lib/getLuma';
import DropDownMenu from '../c_DropDownMenu';

export default class StatusDropDown extends Component {
  static propTypes = {
		dispatch : PropTypes.func.isRequired,
    status: PropTypes.object,
    smallDisplay: PropTypes.bool,
    menuItems: PropTypes.array
	}

  render() {
    const {
      status,
      menuItems,
      onChange,
      smallDisplay
    } = this.props;

    const statusTextColor = getLuma(status.color) > 160 ? 'black' : 'white';


    return (
      <div className={smallDisplay ? 'status-dropdown-small' : 'status-dropdown'}>
        {smallDisplay
          &&
          <div className='status-circle' data-id='Status Icon' style={{backgroundColor: status.color, borderColor: status.color}}></div>
        }
        <DropDownMenu style={!smallDisplay && {backgroundColor: status.color}}
          data-id='Status Dropdown'
          value={status.id}
          staticValue={status.id}
          menuItems={menuItems}
          onChange={onChange}
          labelStyle={!smallDisplay && {color: statusTextColor}}
          iconStyle={!smallDisplay && {fill: statusTextColor}}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/StatusDropDown/index.js